<ng-container *ngIf="!data">
    <div class="block-esquerra">
        <div class="header"></div>
        <div class="nouuid">
            No valid uuid
        </div>
    </div>
</ng-container>
<div *ngIf="data" class="container" [ngClass]="{'obert':paneDretaObert, 'tancat':!paneDretaObert, 'una':data.uniquePhase, 'multiple':!data.uniquePhase, 'bannerHtml':data.bannerHtml, 'bannerText':data.bannerText}">
    <div class="block-esquerra">
        <div class="header">
            <img *ngIf="!logoPropi" _ngcontent-uom-c345="" src="/assets/images/HardmanLogoBlauNom.png"
                alt="Hardman logo" class="logo logoambnom">
            <shared-image class="logo" *ngIf="logoPropi" [image]="logoImage">
            </shared-image>
        </div>
        <div class="titol paddingtop">
            <div class="routeKey">{{data.routeKey}}</div>
            <div class="routeTitle">{{data.title}}</div>
            <div class="clientReferences">{{data.customerReferences}}</div>
            <div class="banner only-bannerHtml" [innerHtml]="data.bannerHtml"></div>
            <div class="banner only-bannerText">{{data.bannerText}}</div>
            <shared-tags-strip-component class="tags nomargin" [tags]="data.userTags"
                [applyColor]="false"></shared-tags-strip-component>

            <routephase-timeline [isExwork]="true" [uuid]="uuid"></routephase-timeline>
            <div *ngIf="data.isGrouped" class="agrupada"></div>
        </div>
        <div *ngIf="data.isChildOfGrouped" class="block-dades">
            <div class="cannot-managment">
                <div class="titol">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.CAPTION' | translate}}</div>
                <div class="text">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.GROUPING.CAPTION' | translate}}</div>
            </div>
            <button-link variant="forward" class="line left" (linkClick)="onLoadNewUUID()">{{
                'SHARED.EXTERNAL.CANNOTMANAGEMENT.LINK.GONEWUUID' | translate}}</button-link>

        </div>
        <div *ngIf="data.isDivided" class="block-dades">
            <div class="cannot-managment">
                <div class="titol">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.CAPTION' | translate}}</div>
                <div class="text">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.DIVIDED.CAPTION' | translate}}</div>
            </div>
        </div>
        <div *ngIf="data.isBrokenForTrucking" class="block-dades">
            <div class="cannot-managment">
                <div class="titol">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.CAPTION' | translate}}</div>
                <div class="text">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.BROKENFORTRUCKING.CAPTION' | translate}}</div>
            </div>
        </div>
        <div *ngIf="data.isTrucked && !data.truckingConfirmed" class="block-dades">
            <div class="cannot-managment pendingtruckingconfirmed">
                <div class="titol">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.TRUCKINGCONFIRMEDPENDING.TITLE' | translate}}</div>
                <div class="text">{{'SHARED.EXTERNAL.CANNOTMANAGEMENT.TRUCKINGCONFIRMEDPENDING.CAPTION' | translate}}
                </div>
            </div>
        </div>

        <div *ngIf="!data.isChildOfGrouped && !data.isDivided && !data.isBrokenForTrucking && !(data.isTrucked && !data.truckingConfirmed) && viewToShow=='general'"
            class="block-dades">
            <shared-exwork-driverplate-component [uuid]="uuid" [data]="data" (refreshData)="onRefreshData()"></shared-exwork-driverplate-component>
            <div class="fases" *ngIf="algoAFer() && data">
                <div class="item only-multiple" [ngClass]="{'showNoRequiresSlot':showNoRequiresSlot}">
                    <div class="titolslot">
                        <span class="title">{{'SHARED.SLOT.PICKER.SLOTS.CAPTION'| translate}}</span>
                        <button-link class="" (linkClick)="showNoRequiresSlot=!showNoRequiresSlot"><span
                                *ngIf="!showNoRequiresSlot">{{
                                'SHARED.ACTIVE.SLOTS.ITEM.SHOWALLPHASES' | translate}}</span><span
                                *ngIf="showNoRequiresSlot">{{
                                'SHARED.ACTIVE.SLOTS.ITEM.SHOWSLOTPHASES' | translate}}</span></button-link>
                    </div>

                    <div class="item" *ngFor="let phase of data.phaseList | sortBy:'phaseCard.executionOrder'">
                        <shared-exwork-phasecard-component [@fadeInOut] [phase]="phase.phaseCard"
                            [ngClass]="{'requiresSlot':phase.requiresSlot,'noRequiresSlot':!phase.requiresSlot}">
                        </shared-exwork-phasecard-component>
                        <shared-exwork-slotpicker-component [@fadeInOut] class="align-right"
                            *ngIf="phase.requiresSlot && !requereixBooking()"
                            [avoidPropertyPendingResponse]="avoidPropertyPendingResponse" [uuid]="uuid"
                            [phase]="phase.phaseCard" (slotChanged)="getDades()" [slotInfo]="phase.slotInfo"
                            [autoOpen]="phase.phaseCard != null && phase.phaseCard.phaseId==phaseIdSelected"
                            [readonly]="data.readonly">
                        </shared-exwork-slotpicker-component>
                    </div>
                </div>
            </div>
            <div *ngIf="esBooking() && !data.readonly && !data.readonlyDataInfo" class="block-dades">
                <shared-exwork-routebooking-component [uuid]="uuid"
                    (onRefreshData)="onRouteBookingRefreshData($event)"></shared-exwork-routebooking-component>
            </div>

            <div class="resafer" *ngIf="!algoAFer()">
                <div class="content" [innerHTML]="'EXTERNAL.NOTHINGTODO' | translate"></div>
            </div>
            <div class="item emails" *ngIf="!data.readonly && !data.readonlyDataInfo">
                <div class="help" [innerHTML]="'SHARED.EXTERNAL.COMPONENT.EMAIL.HELP' | translate"></div>
                <input-component class="col-x" [(ngModel)]="email"
                    placeholder="{{'SHARED.EXTERNAL.COMPONENT.EMAIL.PLACEHOLDER' | translate}}">
                </input-component>
                <button class="link right" (click)="addEmail()">{{'SHARED.EXTERNAL.COMPONENT.EMAIL.BUTTONADD' |
                    translate}}</button>
            </div>
            <div *ngIf="(data.canGrouping || data.isGrouped) && !data.readonly && !data.readonlyDataInfo"
                class="block-links-bottom">

                <button-link *ngIf="data.canGrouping && !data.isGrouped" variant="forward" class="line left"
                    (linkClick)="onClickOption('routeGroup')"><i class="fa fa-object-group option-icon"
                        aria-hidden="true"></i>{{ 'SHARED.EXTERNAL.OPTION.ROUTEGROUP.LINK.GOGROUP' |
                    translate}}</button-link>
                <button-link *ngIf="data.canGrouping && data.isGrouped" variant="forward" class="line left"
                    (linkClick)="onClickOption('routeGroupAdd')"><i class="fa fa-object-group option-icon"
                        aria-hidden="true"></i>{{ 'SHARED.EXTERNAL.OPTION.ROUTEGROUP.LINK.GOADD' |
                    translate}}</button-link>
                <button-link *ngIf="data.canGrouping && data.isGrouped" variant="forward" class="line left"
                    (linkClick)="onClickOption('routeGroupRemove')"><i class="fa fa-object-group option-icon"
                        aria-hidden="true"></i>{{ 'SHARED.EXTERNAL.OPTION.ROUTEGROUP.LINK.GOREMOVE' |
                    translate}}</button-link>
                <button-link *ngIf="data.isGrouped" variant="forward" class="line left"
                    (linkClick)="onClickOption('routeGroupShipment')"><i class="fa fa-eye option-icon"
                        aria-hidden="true"></i>{{
                    'SHARED.EXTERNAL.OPTION.ROUTEGROUPSHIPMENT.LINK.GOLIST' | translate}}</button-link>

                <div *ngIf="data.canGrouping && data.isGrouped && listRouteGroupKeys != null && listRouteGroupKeys.length > 0"
                    class="info-list-routekeys">
                    <div class="info-list-title">
                        {{ 'SHARED.EXTERNAL.ROUTEGROUP.LISTKEYS.TITLE' | translate }}
                    </div>
                    <div class="item-key" *ngFor="let routekey of listRouteGroupKeys">
                        <span class="text">{{ routekey }}</span>
                    </div>

                </div>

            </div>
            <div class="block-links-bottom">
                <button-link variant="forward" class="line left" (linkClick)="onClickOption('properties')"><i
                        class="fa fa-list-alt option-icon" aria-hidden="true"></i>{{
                    'SHARED.EXTERNAL.OPTION.ROUTEPROPERTY.LINK.CAPTION' | translate}}</button-link>
            </div>
            <div class="block-line">
                <div class="cosespendents"
                    *ngIf="data.driverNameIncorrect || data.driverLegalIdentificationIncorrect || data.driverPhoneIncorrect || data.plateAIncorrect || data.plateBIncorrect ||data.plateCIncorrect || data.transportationRegistrationCodeIncorrect || data.carrierNameIncorrect || data.carrierLegalIdentificationIncorrect || data.carrierAddressIncorrect">
                    <div class="titolpendent">{{'SHARED.EXTERNAL.ERROR.TITLE'| translate}}</div>
                    <div class="cosapendent" *ngIf="data.carrierNameIncorrect">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.CARRIERNAMEINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.carrierLegalIdentificationIncorrect">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.CARRIERLEGALIDENTIFICATIONINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.carrierAddressIncorrect">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.CARRIERADDRESSINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.driverNameIncorrect">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.DRIVERNAMEINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.transportationRegistrationCodeIncorrect"><i
                            class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.TRANSPORTATIONREGISTRATIONCODEINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.driverLegalIdentificationIncorrect">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.DRIVERLEGALIDENTIFICATIONINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.driverPhoneIncorrect">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.DRIVERPHONEINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.plateAIncorrect"><i class="fa fa-exclamation-triangle"
                            aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.PLATEAINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="data.plateBIncorrect"><i class="fa fa-exclamation-triangle"
                            aria-hidden="true"></i>
                        {{'SHARED.EXTERNAL.ERROR.PLATEBINCORRECT' | translate}}
                    </div>
                    <div class="cosapendent" *ngIf="!data.hidePlateC && data.plateCIncorrect"><i
                            class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{ data.resourcePlateCIncorrect | translate}}
                    </div>
                </div>
            </div>

        </div>
        <div *ngIf="data.isGrouped && viewToShow=='routeGroupShipment' && !data.readonly && !data.readonlyDataInfo"
            class="block-dades">
            <button-link variant="back" class="line left" (linkClick)="goToNormal()">{{
                'SHARED.EXTERNAL.OPTION.ROUTEGROUPSHIPMENT.LINK.BACK' | translate}}</button-link>
            <shared-route-group-child-list-component [uuidexwork]="uuid"
                [showtitle]="true"></shared-route-group-child-list-component>

        </div>
        <div *ngIf="!data.isChildOfGrouped && (viewToShow=='routeGroup' || viewToShow=='routeGroupAdd' || viewToShow=='routeGroupRemove') && !data.readonly && !data.readonlyDataInfo"
            class="block-dades">
            <button-link variant="back" class="line left" (linkClick)="goToNormal()">{{
                'SHARED.EXTERNAL.OPTION.ROUTEGROUP.LINK.BACK' | translate}}</button-link>
            <shared-exwork-routegroup [uuid]="uuid" [mode]="viewToShow" [route]="data" (goNewUUID)="onGoNewUUID($event)"
                (refreshExwork)="goToNormal()"></shared-exwork-routegroup>
        </div>
        <div *ngIf="viewToShow=='properties'" class="block-dades">
            <button-link variant="back" class="line left" (linkClick)="goToNormal()">{{
                'SHARED.EXTERNAL.OPTION.ROUTEPROPERTY.LINK.BACK' | translate}}</button-link>
            <shared-route-properties [exwork]="true" [uuid]="uuid"
                [readonly]="data.readonly || data.readonlyDataInfo"></shared-route-properties>
        </div>
        <div class="peu">.</div>
    </div>
    <div class="pane-dreta" [ngClass]="this.data.classes">
        <div class="line"></div>
        <div class="button-cycle" (click)="paneDretaObert=!paneDretaObert">
            <i class="only-obert fa fa-chevron-right baixa-data-icon" aria-hidden="true"></i>
            <i class="only-tancat fa fa-chevron-left baixa-data-icon" aria-hidden="true"></i>
        </div>
        <div class="content" [innerHTML]="data.helpHtml"></div>
    </div>
</div>
<div class="signaturahardman">
    <img class="logoimg" src="/assets/images/HardmanLogoBlanc.png" alt="Hardman logo">
    <a href="https:hardman.app" target="_blank" class="powered">{{'GLOBAL.DESENVOLUPATPER' | translate}}</a>
</div>